import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

const colorStyles = ({ theme, variant = 'black', cssProp = 'color', paddingTop }) => {
  const colorMap = {
    ...theme.colors,

    red: theme.colors.r500,
    blue: theme.colors.bl500,
    darkBlue: theme.colors.bl900,
    green: theme.colors.g500,
    lightGrey: theme.colors.n400,
    grey: theme.colors.n700,
    darkGrey: theme.colors.n900,
    brown: theme.colors.b900,
    lightBrown: theme.colors.b300,
    white: theme.colors.white,
    black: theme.colors.black,
    orange: theme.colors.o700,
    grey97: '#979797',
  };

  const color = colorMap[variant];

  return css`
    padding-top: ${paddingTop};
    ${cssProp}: ${color};
    ${cssProp === 'color' &&
    `
      a {
        ${cssProp}: ${color};
      }
    `}
  `;
};

const ColorProvider = styled('div')(colorStyles);

ColorProvider.propTypes = {
  cssProp: PropTypes.oneOf(['color', 'background']),
  variant: PropTypes.string,
};

export default ColorProvider;
